const additionalCode = '';

/** Включение webvisor на всех страницах */
const enableWebvisorAllPages = true;

/**
 * Страницы, на которых должен быть включён webvisor (если enableWebvisorAllPages=false)
 * @example ['/sme/']
 *  */
const webvisorPages = [];

module.exports = {
    additionalCode,
    enableWebvisorAllPages,
    webvisorPages
};
